import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import {
  Router, NavigationStart, NavigationEnd,
  NavigationCancel, NavigationError, Event
} from '@angular/router';
import { filter, Observable } from 'rxjs';
import { BaseUrlChangeDialogComponent } from '../base-url-change-dialog/base-url-change-dialog.component';
import { DialogService } from '../shared/services/decativateDialog/dialog.service';

@Component({
  selector: 'lib1-shared-handler',
  templateUrl: './shared-handler.component.html',
  styleUrls: ['./shared-handler.component.scss'],
})

//can be used to handle tab close events
export class SharedHandlerComponent extends BaseUrlChangeDialogComponent implements OnInit { //, IDeactivateGuard {

  constructor(
    private router: Router,
    public override dialogService: DialogService
  ) {

    super(dialogService);

   }

  
  ngOnInit(): void {

    this.setSubscribers();

  }

  setSubscribers() {

    this.dialogService.showDialogSubjectAsObservable.subscribe((showDialog: boolean) => {

      if (showDialog != null) {

        if (showDialog == false) {

        } else {

          const collection = document.getElementsByClassName("myBtnToOpenModal");

          var btn: HTMLElement = collection[0] as HTMLElement;;

          btn.click();

        }

      }

    });

  }

  leavePage(event: any) {

    this.dialogService.setResponseFromDialog(true);
    
  }

  StayOnPage(event: any) {

    this.dialogService.setResponseFromDialog(false);

    const collection = document.getElementsByClassName("myBtnToCloseModal");

    var btn: HTMLElement = collection[0] as HTMLElement;;

    btn.click();

  }

  doBeforeUnload() {

    


  }

  doUnload() {

    

  }


}
